export const DAYS_OF_WEEK = [
    { key: 'sunday', label: 'Sun', value: 0 },
    { key: 'monday', label: 'Mon', value: 1 },
    { key: 'tuesday', label: 'Tue', value: 2 },
    { key: 'wednesday', label: 'Wed', value: 3 },
    { key: 'thursday', label: 'Thu', value: 4 },
    { key: 'friday', label: 'Fri', value: 5 },
    { key: 'saturday', label: 'Sat', value: 6 },
];

export const DEFAULT_START_TIME = '480'; // 8:00 AM (8 * 60)
export const DEFAULT_END_TIME = '1200'; // 8:00 PM (20 * 60)

export const MAX_TIME_WINDOWS = 4;
